(function () {
  var row = document.querySelector('[data-sp-row]');
  if (!row) return;

  var prevBtn = document.querySelector('[data-sp-prev]');
  var nextBtn = document.querySelector('[data-sp-next]');

  function step(dir) {
    var pill = row.querySelector('.sp__pill');
    var width = pill ? pill.getBoundingClientRect().width : 100;
    var gap = 8;
    row.scrollBy({ left: dir * (width + gap) * 2, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
})();
